import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Times belong to the hotel's clock, not to the device the dashboard happens to run on.
// The API stores instants in UTC, so everything shown is converted to hotel time and
// everything sent keeps the wall clock the staff member typed.
export const HOTEL_TIMEZONE = "Asia/Kolkata";
export const HOTEL_UTC_OFFSET = "+05:30";

export const hotelDayjs = (value) => dayjs(value).tz(HOTEL_TIMEZONE);

// Modals render before their data arrives, and dayjs reads a missing value as "now" —
// which shows the current time as though it were the booking's. Anything missing or
// unparseable renders as the fallback instead of a plausible wrong time.
export function formatHotel(value, pattern, fallback = "") {
    if (value === null || value === undefined || value === "") {
        return fallback;
    }

    const parsed = hotelDayjs(value);

    return parsed.isValid() ? parsed.format(pattern) : fallback;
}

const pad = (value, size = 2) => String(value).padStart(size, "0");

// Keeps the typed wall clock and labels it hotel time: 2 PM on the form is 2 PM at the
// hotel, never shifted by the browser's offset.
export function toHotelISO(value) {
    const date = new Date(value);

    return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
        `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` +
        `.${pad(date.getMilliseconds(), 3)}${HOTEL_UTC_OFFSET}`
    );
}

// For "HH:mm" fields such as restaurant opening hours, which carry no date of their own.
export function timeToHotelISO(timeString, baseDate = new Date()) {
    const [hours, minutes] = String(timeString).split(":");
    const date = new Date(baseDate);
    date.setHours(Number(hours), Number(minutes), 0, 0);

    return toHotelISO(date);
}
